import { render, staticRenderFns } from "./steps.vue?vue&type=template&id=3c6b6dc0&"
import script from "./steps.vue?vue&type=script&lang=js&"
export * from "./steps.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/data/builds/MWmsPKDH/0/framework/qmai-ui/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3c6b6dc0')) {
      api.createRecord('3c6b6dc0', component.options)
    } else {
      api.reload('3c6b6dc0', component.options)
    }
    module.hot.accept("./steps.vue?vue&type=template&id=3c6b6dc0&", function () {
      api.rerender('3c6b6dc0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "packages/steps/src/steps.vue"
export default component.exports